<form-layout [showSave]="canSave" (onSave)="onSaveClick()" (onBack)="onBackClick()" (onNext)="onSaveAndNextClick()" (onSubmit)="onSubmitClick()" [showSubmit]="canSubmit" [isSubmitDisabled]="isSubmitDisabled" >
    <form [formGroup]="form" class="d-flex flex-column space-y-4">
        <div class="grid grid-cols-1 lg:grid-cols-4">
            <div class="col-span-3 grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <kendo-formfield class="col-span-1">
                        <kendo-label class="form-label" [for]="neuerProjektstart" text="{{'aenderungsantrag.neuerProjektstart' | translate }} *" [infotooltip]="'aenderungsantrag.neuerProjektstart'"></kendo-label>
                        <kendo-datepicker
                            #neuerProjektstart
                            (valueChange)="onProjektStartChange($event)"
                            formControlName="neuerProjektStart"
                            [appinfotext]="'aenderungsantrag.neuerProjektstart'"
                            [format]="dateFormat"
                            [incompleteDateValidation]="true"></kendo-datepicker>
                    </kendo-formfield>
                </div>
                <div>
                    <kendo-formfield class="col-span-1" [ngClass]="{ 'opacity-50': !neuerProjektstart.value }">
                        <kendo-label class="form-label" [for]="projektEnd" text="{{'aenderungsantrag.neuesProjektende' |translate}} *" [infotooltip]="'aenderungsantrag.neuesProjektende'"></kendo-label>
                        <kendo-datepicker
                            #projektEnd
                            formControlName="neuesProjektEnde"
                            [min]="neuerProjektstart.value ?? noMinDate()"
                            [readonly]="!neuerProjektstart.value || this.form.disabled"
                            [disabled]="!neuerProjektstart.value || this.form.disabled"
                            [appinfotext]="'aenderungsantrag.neuesProjektende'"
                            [incompleteDateValidation]="true"
                            [format]="dateFormat"></kendo-datepicker>
                            <kendo-formerror *ngIf="endBeforeStartErrorMessage">{{ endBeforeStartErrorMessage }}</kendo-formerror>
                    </kendo-formfield>
                </div>
            </div>
        </div>

        <kendo-formfield class="text" showHints="initial">
            <kendo-label class="form-label" text="{{'aenderungsantrag.kommentar' | translate}}"
                [infotooltip]="'aenderungsantrag.kommentar'" [for]="kommentar"></kendo-label>
            <kendo-textarea #kommentar formControlName="kommentar" appinfotext="aenderungsantrag.kommentar"
                [attr.aria-label]="'aenderungsantrag.kommentar' | translate" [maxlength]="aenderungsantragConfig.KOMMENTAR_MAXLENGTH" [rows]="8"
                [appinfotext]="'aenderungsantrag.kommentar'"
                (paste)="this.textBoxService.onPaste($event, this.form.Kommentar, aenderungsantragConfig.KOMMENTAR_MAXLENGTH)"></kendo-textarea>
        </kendo-formfield>

    </form>
    <form [formGroup]="attachmentProcessStepForm" class="mt-6">
        <attachments formControlName="attachments" [documentTypes]="documentTypes" [AnfrageId]="anfrage.id" [rechtsform]="rechtsform"></attachments>
    </form>
</form-layout>